import type {
    TSandboxPoint,
    TSandboxSize
} from '@/modules/Sandbox/Sandbox.store.ts';
import {
    SANDBOX_BOTTOM_EDGE_OFFSET,
    SANDBOX_RIGHT_EDGE_OFFSET,
    SANDBOX_SIZE_LIMITS,
    SANDBOX_VIEWPORT_PADDING
} from '@/pages/Project/components/Sandbox/Sandbox.constants';

export const clampSandboxPosition = (
    point: TSandboxPoint,
    size: TSandboxSize
): TSandboxPoint => {
    const maxX = window.innerWidth - SANDBOX_RIGHT_EDGE_OFFSET;
    const maxY = window.innerHeight - SANDBOX_BOTTOM_EDGE_OFFSET;
    return {
        x: Math.max(
            SANDBOX_VIEWPORT_PADDING - size.width + SANDBOX_RIGHT_EDGE_OFFSET,
            Math.min(maxX, point.x)
        ),
        y: Math.max(SANDBOX_VIEWPORT_PADDING, Math.min(maxY, point.y))
    };
};

export const clampSandboxSize = (size: TSandboxSize): TSandboxSize => ({
    width: Math.max(
        SANDBOX_SIZE_LIMITS.minWidth,
        Math.min(SANDBOX_SIZE_LIMITS.maxWidth, size.width)
    ),
    height: Math.max(
        SANDBOX_SIZE_LIMITS.minHeight,
        Math.min(SANDBOX_SIZE_LIMITS.maxHeight, size.height)
    )
});
